import { type FC, useState, useEffect } from "react";
import Modal from "@root/shared/components/Modal";
import { Icon } from "@root/shared/components/Icon";
import * as styles from "./styles.css";

type Props = {
  showModal: boolean;
  title?: string;
  description?: React.ReactNode;
};

export const ApplicationErrorNoticeModal: FC<Props> = ({
  showModal: initialShowModal,
  title = "申請内容にエラーがあります。",
  description = (
    <>
      赤文字のエラー箇所を修正のうえ、
      <br />
      再度申請をお願いいたします。
    </>
  ),
}) => {
  const [showModal, setShowModal] = useState(initialShowModal);

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [showModal]);

  return (
    <Modal
      isShow={showModal}
      spAppearanceType="center"
      pcWidthType="small"
      headerTitleStyle="none"
      footerContentStyle="none"
      onClose={() => setShowModal(false)}
    >
      <div className={styles.contentsWrapper}>
        <p className={styles.errorTitle}>
          <Icon name="attention" fontSize="16px" />
          {title}
        </p>
        <p className={styles.description}>{description}</p>
      </div>
    </Modal>
  );
};
